// extracted by mini-css-extract-plugin
export default {"nav":"Sidebar_nav__aELub","menuHeader":"Sidebar_menuHeader__OVUED"};